define( 'application/views/ApplicationView', [
    'application/templates/application',
    'application/delegate/ApplicationDelegate',
    'components/factory/Factory',
    'components/popin/Popin',
    'components/ecrinbridge/EcrinBridge',
    'components/trackingbridge/TrackingBridge',
    'config/config.tracking',
    'specific/filtermanager/models/FilterManagerModel',
    'specific/filtermanager/views/FilterManagerView',
    'specific/mosaic/models/MosaicModel',
    'specific/mosaic/views/MosaicView',
    'specific/instagram/models/InstagramModel',
    'specific/instagram/views/InstagramView',
    'specific/apibridge/ApiBridge',
    'specific/apibridge/ApiBridge2',
    'specific/header/models/HeaderModel',
    'specific/header/views/HeaderView',
    'specific/footer/models/FooterModel',
    'specific/footer/views/FooterView'
], function ( appTpl,
    ApplicationDelegate,
    Factory,
    Popin,
    EcrinBridge,
    TrackingBridge,
    tagPlan,
    FilterManagerModel,
    FilterManagerView,
    MosaicModel,
    MosaicView,
    InstagramModel,
    InstagramView,
    ApiBridge,
    ApiBridge2,
    HeaderModel,
    HeaderView,
    FooterModel,
    FooterView
) {

    var ApplicationView = Mazarine.View.extend( {

        events: {
            "click .js-maz-video-iphone": "onClickVideoIphone"
        },

        appTemplate: appTpl,

        el: "#maz-dior-content",

        $window: $( window ),
        $html_body: $( 'html, body' ),

        filterManagerView: null,
        mosaicView: null,
        mosaicView2: null,

        nbImagesToShow: 18,
        nbImagesToAdd: 18,

        nbImagesToShow2: 6,
        nbImagesToAdd2: 18,

        lastScrollTop: 0,
        hasNewEcrin: false,

        initialize: function ( options ) {
            this.viewmodel = options.viewmodel;
            this.datas = options.datas;
            this.config = options.config;
            this.wording = options.wording;
            this.router = options.router;
            this.isMobile = ( this.config.deviceEnv === "mobile" );
            this.isTablet = this.config.deviceEnv !== 'mobile' && navigator.userAgent.match( /iPad/i );
            this.config.isIOS = /iPad|iPhone|iPod/.test( navigator.userAgent ) && !window.MSStream;
            this.config.isPcd = window.univers === 'pcd';

            if( this.isMobile ) {
                this.nbImagesToShow = 9;
                this.nbImagesToAdd = 9;
            }

            ApiBridge.initialize( {
                config: this.config,
                authToken: this.datas.trends.authToken,
                customerId: this.datas.trends.customerId
            } );
            ApiBridge2.initialize( {
                config: this.config,
                authToken: this.datas.trends.authToken,
                customerId: this.datas.trends.customerId
            } );
            EcrinBridge.initialize( {
                "config": this.config,
                "callbacks": {
                    "onAddItemToCartCallback": !this.isMobile ? _.bind(this.closePopin, this) : false
                }
            } );
            TrackingBridge.initialize( {
                "config": this.config,
                "tagPlan": tagPlan,
                "api": this.config.trackingAPI
            } );
            ApplicationDelegate.initialize( {
                "datas": this.datas,
                "config": this.config
            } );
            Factory.initialize( {
                "delegate": ApplicationDelegate,
            } );

            this.render();

            var throttledOnResize = _.throttle( this.onResize, 500 );
            this.$window.on( 'resize', _.bind( throttledOnResize, this ) );
            this.$window.on( 'scroll', _.bind( this.onScroll, this ) );

            $('html').addClass(this.config.locale);
        },

        render: function () {
            this.$el.append( this.appTemplate( { wording: this.datas.wording, isMobile: this.isMobile } ) );

            //Change header color
            if (window.diorV7 && window.diorV7.Header) {
                window.diorV7.Header.toFluid();
            }

            this.afterRender();
        },

        afterRender: function () {
            if ( this.isMobile ) {
                $( 'html' ).addClass( 'maz-mobile' );
            }

            if ( this.config.isIOS ) {
                $( 'body' ).addClass( 'maz-ios' );
            }

            this.createFilterView();
            this.createInstagramView();
            this.createMosaicView();
            this.createMosaicView2();

            ApiBridge.updateFilters([this.datas.trends.filters[0].id]);
            ApiBridge.requestDatas( this.nbImagesToShow, _.bind( this.mosaicView.onRequestSuccess, this.mosaicView), true);

            ApiBridge2.updateFilters([this.datas.trends.filters[1].id]);
            ApiBridge2.requestDatas( this.nbImagesToShow2, _.bind( this.mosaicView2.onRequestSuccess, this.mosaicView2), true);

            //check if params get for new header
            this.checkIfNewHeaderNeeded();
        },

        checkIfNewHeaderNeeded: function() {

            var isEcrinHorizon = this.datas.header.ecrinHorizon;

            if ( isEcrinHorizon ) {
                this.setNewEcrin();
            } else {
                $('body').addClass('has-default-ecrin');
            }

        },

        setNewEcrin: function() {

            this.hasNewEcrin = true;
            $('body').addClass('has-new-ecrin');

            // Create maz header
            this.createMazHeader();

            //Create maz footer
            this.createMazFooter();

        },

        createMazHeader: function() {

            var headerModel = new HeaderModel({
                type: "headerview",
                viewId: "header-view",
                datas: this.datas.header,
                config: this.config,
                isChina: this.locale === 'zh_cn'
            });

            var headerView = new HeaderView({
                model: headerModel
            });
            this.$('.maz-header-wrapper').html(headerView.render());

        },

        createMazFooter: function() {

            var footerModel = new FooterModel({
                type: "footerview",
                viewId: "footer-view",
                datas: this.datas.footer,
                config: this.config,
                isChina: this.locale === 'zh_cn'
            });

            var footerView = new FooterView({
                model: footerModel
            });
            this.$('.maz-footer-wrapper').html(footerView.render());

        },

        onLoaderAnimationComplete: function() {
            console.log("onLoaderAnimationComplete", "ApplicationView");

            if ( this.pageManagerView && this.pageManagerView.onLoaderAnimationComplete ) {
                this.pageManagerView.onLoaderAnimationComplete();
            }

            if ( this.instagramView && this.instagramView.onLoaderAnimationComplete ) {
                this.instagramView.onLoaderAnimationComplete();
            }
        },

        createFilterView: function() {
            var filters = this.datas.trends.filters;

            var obj = {
                type: 'filtermanagerview',
                viewId: 'filtermanager',
                filters: filters,
                currentFilterId: [ filters[0].id ],
                intro: this.datas.intro,
                config: this.config,
                isMobile: this.isMobile
            };

            var model = new FilterManagerModel( obj );

            this.listenTo(model, 'change:currentFilterId', this.onCurrentFilterChange);

            this.filterManagerView = new FilterManagerView({
                model: model,
                requestRoute: _.bind( function( route, silent ) {
                    this.router.setRoute( route, silent );
                }, this)
            });

            this.$('.maz-dior-layout').append( this.filterManagerView.render().$el );
            this.filterManagerView.afterRender();
        },

        createInstagramView: function() {
            var obj = this.datas.instagram;
            obj.isMobile = this.isMobile;
            obj.requestOpenPopin = _.bind( this.openPopin, this );
            var model = Factory.createModelFromData(obj);

            this.instagramView = Factory.createViewFromModel(model);

            this.$('.maz-dior-layout').append( this.instagramView.render().$el );
            this.instagramView.afterRender();
        },

        createMosaicView: function() {

            var obj = {
                type: 'mosaicview',
                viewId: 'mosaicmanager',
                nbImagesToAdd: this.nbImagesToAdd,
                config: this.config,
                requestOpenPopin: _.bind( this.openPopin, this ),
                pictures: this.datas.pictures
            };

            var model = Factory.createModelFromData( obj );

            this.listenTo(model, 'change:nbImagesRequested', this.onNbImagesRequestedChange);
            this.listenTo(model, 'change:onReady', this.onContentReady);

            this.mosaicView = Factory.createViewFromModel( model );

            this.$('.maz-dior-layout').append( this.mosaicView.render().$el );
            this.mosaicView.afterRender();
        },

        createMosaicView2: function() {
            var obj = {
                type: 'mosaicview',
                viewId: 'mosaicmanager2',
                bestOf: true,
                nbImagesToAdd: this.nbImagesToAdd2,
                config: this.config,
                requestOpenPopin: _.bind( this.openPopin, this )
            };

            var model = new MosaicModel( obj );

            this.listenTo(model, 'change:nbImagesRequested', this.onNbImagesRequestedChange2);
            this.listenTo(model, 'change:onReady', this.onContentReady);

            this.mosaicView2 = new MosaicView({
                model: model,
                requestRoute: _.bind( function( route, silent ) {
                    this.router.setRoute( route, silent );
                }, this)
            });

            this.$('.maz-dior-layout').append( this.mosaicView2.render().$el );
            this.mosaicView2.afterRender();
        },

        onCurrentFilterChange: function( model, currentFilterId ) {
            this.mosaicView.waitForRequest();

            ApiBridge.updateFilters( currentFilterId );
            ApiBridge.requestDatas(  this.nbImagesToShow, _.bind( this.mosaicView.onRequestSuccess, this.mosaicView), true );
        },

        onNbImagesRequestedChange: function( model, nbImagesRequested ) {
            if( nbImagesRequested > 0 ) {
                ApiBridge.requestDatas( nbImagesRequested, _.bind( this.mosaicView.onRequestSuccess, this.mosaicView), false );
            }
        },

        onNbImagesRequestedChange2: function( model, nbImagesRequested ) {
            if( nbImagesRequested > 0 ) {
                ApiBridge2.requestDatas( nbImagesRequested, _.bind( this.mosaicView2.onRequestSuccess, this.mosaicView2), false );
            }
        },

        openPopin: function ( id, olapicService, bestOf ) {
            console.log(id, olapicService, bestOf);
            var modelDatas;
            var mosaicView = (bestOf) ? 'mosaicView2' : 'mosaicView';

            if( olapicService ){
                //Set specific olapic model
                modelDatas = {
                    type: 'pushdetails',
                    viewId: 'pushdetails-' + id,
                    datas: this[mosaicView].getItemDatasById( id ),
                    previousLink: this[mosaicView].getPreviousId( id ),
                    nextLink: this[mosaicView].getNextId( id ),
                    handleClickPrevious: _.bind( function( ) {
                        this.openPopin( this[mosaicView].getPreviousId( id ), olapicService, bestOf );
                    }, this ),
                    handleClickNext: _.bind( function( ) {
                        this.openPopin( this[mosaicView].getNextId( id ), olapicService, bestOf );
                    }, this )
                };
            }else{
                // Search object with viewId = id in this.datas.popins
                modelDatas = _.findWhere( this.datas.popins, {
                    "viewId": id
                } );
            }

            if ( modelDatas.type === 'productview' ) {
                modelDatas.isPopinProduct = true; // For tracking
            }

            // Create model & view for object
            var _model = Factory.createModelFromData( modelDatas );
            var _view = Factory.createViewFromModel( _model );

            if ( !_.isNull( _model ) && !_.isNull( _view ) ) {

                // Configure how to open popin
                var attachPopin = "#maz-dior-content";
                var popinScrollMode = "external";

                if ( this.config.deviceEnv == "mobile" ) {
                    // On mobile we use native scroll mode so we hide minisite content and save scroll position
                    attachPopin = "#maz-dior-content-mobile";
                    $( '#maz-dior-content-mobile' ).remove();
                    this.$( '.maz-dior-layout' ).after( '<div id="maz-dior-content-mobile"></div>' );
                    popinScrollMode = "native";

                    if ( !Popin.isOpen( "main-popin" ) ) {
                        this.mainYpos = $( 'body' ).scrollTop();
                    }

                    $( '.maz-dior-layout' ).hide();
                    EcrinBridge.showHeader( true );
                } else {
                    $( 'html' ).css( 'overflow', 'hidden' );
                }

                var onContentReadyCallback = _.bind(function(duration) {
                    if( modelDatas.type === 'productview' && !this.isMobile ) {
                        this.$('.maz-popin-content').css({
                            overflow: 'initial',
                            height: 'auto'
                        });
                    }

                    // fix IOS8
                    if ( this.isTablet ) {
                        this.$( '.maz-popin-content' ).css( 'height', ( this.$( '.maz-popin' ).height() - this.$( '.maz-popin-header' ).outerHeight( true ) ) + 'px' );
                    }
                }, this);

                var openPopinContentRendered = _.bind(function(duration) {

                    if( modelDatas.type === 'productview' && !this.isMobile ) {
                        this.$('.maz-popin-content').css({
                            overflow: 'hidden',
                            height: '542px'
                        });
                    }
                }, this);

                var closePopinAnimation = function (callback) {
                    var tl = new TimelineLite();

                    tl.to(_view.$el.parents('.maz-popin'), 0.6, {ease: Power2.easeOut, autoAlpha: 0}, 0.4);
                    tl.to(_view.$el.parents('.maz-popin-wrapper').find('.maz-overlay'), 0.6, {ease: Power3.easeIn, autoAlpha: 0}, 0);

                    _.delay(callback, tl._duration * 1010);
                };

                // Describe how to open popin
                var popinModelData = _.extend( {
                    "attach": attachPopin,
                    "view": _view,
                    "popinType": "popin",
                    "withBackToTopButton": modelDatas.type === 'multimediasview',
                    "popinViewClass": modelDatas.type,
                    "popinCustomClass": modelDatas.viewId,
                    "onManualCloseCallback": _.bind( function () {

                        this.router.setRoute( {
                            popin: null
                        }, true );

                        if ( this.config.deviceEnv === "mobile" ) {
                            $( '#maz-dior-content-mobile' ).remove();
                            $( '.maz-dior-layout' ).show();
                            $('html').removeClass('maz-popin-opened');
                            $( 'html, body' ).scrollTop( this.mainYpos );
                        } else {
                            $( 'html' ).css( 'overflow', 'auto' );
                        }

                    }, this ),
                    "popinScrollMode": popinScrollMode,
                    "onBeforeCloseCallback": this.isMobile ? false : _.bind(closePopinAnimation, this),
                    "onContentReadyCallback": _.bind(onContentReadyCallback, this),
                    "onContentRendered": this.isMobile ? false : _.bind(openPopinContentRendered, this)
                }, modelDatas );

                if( id === 'quickbuy' && !this.isMobile ) {
                    if( this.config.ecommerce === 'shop' ) {
                        popinModelData.popinTitle = this.datas.wording.quickbuyPopinTitleShop;
                    } else if( this.config.ecommerce === 'retailer' ) {
                        popinModelData.popinTitle = this.datas.wording.quickbuyPopinTitleRetailer;
                    }
                }

                // Open popin
                Popin.open( "main-popin", popinModelData );
                var popinInRoute = this.router.getSegment().popin;

                if ( !this.isMobile ) {
                    // Animate popin opening
                    this.$( '.maz-popin-wrapper' ).css( {
                        'overflow-x': 'hidden',
                        'overflow-y': 'scroll'
                    } );

                    var tl = new TimelineLite();

                    tl.set(_view.$el.parents('.maz-popin'), {autoAlpha: 0});

                    if(!popinInRoute) {
                        tl.set(_view.$el.parents('.maz-popin-wrapper').find('.maz-overlay'), {autoAlpha: 0});
                    }
                    tl.to(_view.$el.parents('.maz-popin'), 0.6, {ease: Power3.easeIn, autoAlpha: 1}, 0);
                    tl.to(_view.$el.parents('.maz-popin-wrapper').find('.maz-overlay'), 0.6, {ease: Power3.easeIn, autoAlpha: 0.7}, 0);

                } else {
                    if ( modelDatas.type === 'videoview' ) {
                        this.$( '.maz-popin-wrapper' ).height( $( window ).height() - $('#ecrin-header').outerHeight() );
                        _view.$el.fillorfit( {
                            method: 'fit'
                        }, function () {} );
                    } else if ( modelDatas.type === 'viewerview' ) {
                        this.$( '.maz-popin-wrapper' ).height( $(window).height() - $('#ecrin-header').outerHeight());
                    } else {
                        this.$( '.maz-popin-wrapper' ).height( 'auto' );
                    }
                }

                if ( popinModelData.popinScrollMode === "external" ) {
                    _.delay( _.bind( function () {
                        this.$( '.maz-overlay' ).height( this.$( '.maz-popin' ).outerHeight( true ) );
                    }, this ), 500 );
                }

                // dirty fix ( scrollbar ie9 )
                var ie = ( !!window.ActiveXObject && +( /msie\s(\d+)/i.exec( navigator.userAgent )[ 1 ] ) ) || NaN;
                if ( ie === 9 ) {
                    $( '.maz-popin-wrapper' ).css( 'width', $( window ).width() + 17 );
                }
            } else {
                console.warn( "[ApplicationView -> openPopin] View or Model undefined", _view, _model );
            }
        },

        closePopin: function ( id ) {
            Popin.close( "main-popin", true );
        },

        onResize: function ( e ) {
            // this.pageManagerView.onResize( e, this.getOrientation() );
        },

        onScroll: function ( e ) {

            if ( this.hasNewEcrin ) {
                // Detect scroll direction
                var st = window.pageYOffset || document.documentElement.scrollTop;
                if ( st > this.lastScrollTop ) {
                    this.manageNewEcrin('down');
                } else {
                    this.manageNewEcrin('up');
                }
                this.lastScrollTop = st <= 0 ? 0 : st;
            }

        },

        manageNewEcrin: function( direction ) {

            var newEcrin = $('.maz-header');

            if ( direction === 'up' ) {
                newEcrin.removeClass('maz-header-hide');
            } else {
                newEcrin.addClass('maz-header-hide');
            }

        }

    } );

    return ApplicationView;
} );
